import { apiV2 } from "../../api/axiosConfig";
import { PaginatedResponse } from "../../types/PaginatedResponse";
import { Client } from "../../types/userManagement";
import { useQuery } from "react-query";

export const fetchSearchClient = async (
  search: string,
  rpp = 20,
  clientID: string | null = null,
  module: string | undefined = undefined,
  page = 1,
) => {
  try {
    const params: Record<string, string> = {
      search,
      rpp: `${rpp}`,
      page: `${page}`,
    };

    if (clientID) {
      params["clientID"] = clientID;
    }

    if(module){
        params["module"] = module;
    }

    const res = await apiV2.get<PaginatedResponse<Client>>("/clients", { params });
    return res.data;
  } catch (e) {
    console.error(e);
  }
};

export const useClientSearch = (
  search: string,
  rpp = 20,
  clientID: string | null = null
) => {
  return useQuery(["clients", search], () => fetchSearchClient(search, rpp, clientID), {});
};
